// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"c706a5f2","599":"0eb7cb2f","787":"aa64b8f8"}[chunkId] + ".chunk.js";
};